import template from './commercial-has.jade';

export default angular.module('cian.addForm.commercialHas', []).directive('cianAfAboutBuildingCommercialHas', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller() {
    this.fields = [
      {
        inputName: 'hasElectricity',
        modelName: 'hasElectricity',
        fieldName: 'Электричество',
      },
      {
        inputName: 'hasHeating',
        modelName: 'hasHeating',
        fieldName: 'Отопление',
      },
      {
        inputName: 'hasDrainage',
        modelName: 'hasDrainage',
        fieldName: 'Канализация',
      },
      {
        inputName: 'hasGas',
        modelName: 'hasGas',
        fieldName: 'Газ',
      },
      {
        inputName: 'hasWater',
        modelName: 'hasWater',
        fieldName: 'Водоснабжение',
      },
      {
        inputName: 'hasLift',
        modelName: 'hasLift',
        fieldName: 'Лифт',
      },
      {
        inputName: 'hasParking',
        modelName: 'hasParking',
        fieldName: 'Парковка',
      },
      {
        inputName: 'hasSecurity',
        modelName: 'hasSecurity',
        fieldName: 'Охрана',
      },
      {
        inputName: 'hasInternet',
        modelName: 'hasInternet',
        fieldName: 'Интернет',
      },
    ];
  },
  controllerAs: 'commercialHas',
  template,
})).name;
